<template>
  <div class="wrapper">
    <div class="product-info">
      <div class="header">
        <div class="detail">
          <p class="name">{{ currentProduct.shortName }}</p>
          <p v-if="insuranceInfo.tag" class="tag">
            <span>{{ insuranceInfo.tag }}</span>
          </p>
        </div>
        <div class="true-name">{{ currentProduct.productActualName }}</div>
      </div>
      <div class="company">
        <p class="title">
          <span>承</span><span>保</span><span>机</span><span>构</span>
        </p>
        <p>：</p>
        <span>{{ currentProduct.productCompany }}</span>
      </div>
      <div class="date">
        <p class="title"><span>有</span><span>效</span><span>期</span></p>
        <p>：</p>
        <div class="date-wrapper">
          <p
            v-if="!supportPriceCalendar && !startTime"
            class="select-start-time"
            @click="selectDate"
          >
            选择起始日期
          </p>
          <p v-else class="start-time" @click="selectDate">
            {{ startTime ? startTime : '-' }}
          </p>
          <p class="zhi">至</p>
          <p class="end-time">
            {{ endTime ? endTime : '-' }}
          </p>
        </div>
      </div>
    </div>

    <div v-if="currentProduct.isChild" class="guardian-wrapper">
      <div class="header">
        监护人
        <span>监护人只能为领取人的父母 </span>
        <p
          v-if="guardianTemp && guardianTemp.tpid"
          class="add"
          @click="add(true)"
        >
          更换监护人
        </p>
      </div>
      <insurance-item
        v-if="guardianTemp && guardianTemp.tpid"
        ref="guardianRef"
        class="person-wrapper"
        :item="guardianTemp"
        isGuardian
        @delete="deleteItem"
      />
      <div
        v-if="!guardianTemp || !guardianTemp.tpid"
        class="add-big"
        @click="add(true)"
      >
        添加监护人
      </div>
    </div>

    <div class="receive-wrapper">
      <div class="header">
        <p class="title">领取人</p>
        <p class="num">
          共{{ travelPeronNum }}人，还需添加<span>{{ leftNum }}</span
          >位
        </p>
        <p
          v-if="selectTempList && selectTempList.length > 0"
          class="add"
          @click="add(false)"
        >
          添加/更换领取人
        </p>
      </div>
      <p v-if="isChild" class="trip">
        温馨提示：如领取人来自多个家庭关系，请拆分门票按照单个家庭独立购买～
      </p>
      <div class="divider"></div>
      <div
        v-if="!selectTempList || selectTempList.length === 0"
        class="add-big"
        @click="add(false)"
      >
        添加领取人
      </div>
      <ul>
        <insurance-item
          v-for="(item, index) in showTempList"
          :key="index"
          class="person-wrapper"
          ref="insuranceRef"
          :item="item"
          :isChild="isChild"
          @delete="deleteItem"
        />
      </ul>
      <div
        v-if="selectTempList && selectTempList.length > 2"
        class="btn-wrapper"
      >
        <p @click="clickFold">
          {{ isFold ? '展开全部游客信息' : '折叠部分游客信息'
          }}<van-icon class="icon" :name="isFold ? 'arrow-down' : 'arrow-up'" />
        </p>
      </div>
    </div>
    <p v-if="insuranceInfo.trips" class="explain">{{ insuranceInfo.trips }}</p>

    <div v-if="$route.query.viewName === 'addUserForInsurance'" class="bottom">
      <div class="agreement">
        <img
          :src="
            isAgree
              ? require('@/assets/images/icon_agree.png')
              : require('@/assets/images/icon_insuring_normal.png')
          "
          @click="agree"
        />
        <p>
          我已阅读
          <span @click="goAgreement(1)">《领取规则》</span>
          <span @click="goAgreement(2)">《用户协议》</span>
          并同意保险公司致电确认该赠险相关事宜
        </p>
      </div>
      <div class="btn" @click="confirm">我已阅读并确认领取</div>
      <div class="menu_wkBox_back_box"></div>
    </div>

    <van-popup
      v-if="!supportPriceCalendar"
      v-model="datePickerShow"
      position="bottom"
    >
      <van-datetime-picker
        v-model="datePickerValue"
        type="date"
        title="日期选择"
        :min-date="datePickerMin"
        :max-date="datePickerMax"
        @confirm="datePickerConfirm"
        @cancel="datePickerShow = false"
      >
      </van-datetime-picker>
    </van-popup>
    <van-popup
      class="popup"
      v-model="showSelectPopup"
      round
      position="bottom"
      :style="{ height: '60%' }"
      closeable
      @close="hidePopup"
    >
      <div class="popup-title pf-medium">
        选择{{ isAddGuardian ? '监护人' : '领取人' }}
      </div>
      <div class="bd">
        <person-index
          v-if="isInitialized"
          :isPopup="true"
          :numIn="isAddGuardian ? 1 : travelPeronNum"
          :tpidsIn="isAddGuardian ? guardianIds : tpids"
          :allList="isAddGuardian ? popupGuardianListData : popupListData"
          @usePersonList="usePersonList"
          @removed="onRemoved"
          @modify="onModify"
          @unshiftPerson="unshiftPersonWithoutChecked"
        ></person-index>
      </div>
    </van-popup>
    <van-popup
      class="popup"
      v-model="showEditPopup"
      round
      position="bottom"
      :style="{ height: '60%' }"
      closeable
      @close="hideEditPopup"
    >
      <div class="popup-title pf-medium">
        {{ editingPerson.index === -1 ? '新增' : '编辑' }}
      </div>
      <div class="bd">
        <person-edit
          :isPopup="true"
          v-if="isEditInitialized"
          :person="editingPerson"
          @back="onEditBack"
          @editSuccess="onEditSuccess"
          @removed="onRemoved"
        ></person-edit>
      </div>
    </van-popup>
    <MockRouterAction
      v-if="isActionSheetShow"
      title-from="确认领取人信息"
      :title-to="htmlTitle"
      ref="mra"
    >
      <div class="agreement" v-html="htmlContent"></div>
    </MockRouterAction>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Popup, DatetimePicker, Field, Toast, Icon } from 'vant'
import dayjs from 'dayjs'
import InsuranceItem from '@/components/confirm/InsuranceItem'
import bus from '@/Bus/travel-person'
import personIndex from '@/router/home/components/confirm/select-person/person/index.vue'
import personEdit from '@/router/home/components/confirm/select-person/person-edit/index.vue'
import { mapState } from 'vuex'
import MockRouterAction from '@/components/mockRouterAction/index.vue'
const {
  mapState: mapStateNs,
  mapMutations: mapMutationNs,
  mapActions
} = createNamespacedHelpers('insurance')
const minDate = dayjs().add(1, 'day').toDate()
const maxDate = dayjs().add(365, 'day').toDate()
const AGREE_KEY = 'isAgreeInsurance'
export default {
  data() {
    return {
      isAgree: localStorage.getItem(AGREE_KEY) ? true : false,
      isFold: true,
      childTempSelectList: [],
      adultTempSelectList: [],
      //监护人
      guardianTemp: undefined,
      datePickerShow: false,
      datePickerMin: minDate,
      datePickerMax: maxDate,
      datePickerValue: minDate,
      showSelectPopup: false,
      showEditPopup: false,
      isInitialized: false,
      isEditInitialized: false,
      editingPerson: {},
      htmlTitle: '',
      htmlContent: '',
      isAddGuardian: false //是否添加监护人
    }
  },
  components: {
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [DatetimePicker.name]: DatetimePicker,
    personIndex,
    personEdit,
    MockRouterAction,
    InsuranceItem,
    InsuranceItem
  },
  computed: {
    ...mapStateNs([
      'currentProduct',
      'insuranceInfo',
      'supportPriceCalendar',
      'selectPriceCalendarDate',
      'startTime',
      'endTime',
      'travelAdultPersonNum',
      'travelChildPersonNum',
      'travelPersonList',
      'listHorizonAll',
      'schemeTravPerson', //选中的出行人数据
      'schemeTicketTaker' //选中的取票人数据
    ]),
    ...mapState(['isActionSheetShow']),
    showTempList() {
      if (
        this.selectTempList &&
        this.selectTempList.length > 2 &&
        this.isFold
      ) {
        return this.selectTempList.filter((_, index) => index <= 1)
      } else {
        return this.selectTempList
      }
    },
    tpids() {
      return this.selectTempList.map(item => item.tpid)
    },
    guardianIds() {
      if (this.guardianTemp && this.guardianTemp.tpid) {
        return [this.guardianTemp.tpid]
      }
      return []
    },
    travelPeronNum() {
      return this.currentProduct.isChild
        ? this.travelChildPersonNum
        : this.travelAdultPersonNum
    },
    leftNum() {
      return this.travelPeronNum - this.selectTempList.length
    },
    isChild() {
      return this.currentProduct.isChild
    },
    selectTempList: {
      get() {
        return this.currentProduct.isChild
          ? this.childTempSelectList
          : this.adultTempSelectList
      },
      set(val) {
        if (this.currentProduct.isChild) {
          this.childTempSelectList = val
        } else {
          this.adultTempSelectList = val
        }
      }
    },
    popupListData() {
      return this.travelPersonList.map(x => {
        const isChecked = this.tpids.indexOf(x.tpid) > -1
        return {
          ...x,
          isChecked
        }
      })
    },
    popupGuardianListData() {
      return this.travelPersonList.map(x => {
        const isChecked = this.guardianIds.indexOf(x.tpid) > -1
        return {
          ...x,
          isChecked
        }
      })
    }
  },
  mounted() {
    //日期不可选
    if (
      this.schemeTravPerson &&
      this.schemeTravPerson.fields &&
      this.schemeTravPerson.fields.length > 0
    ) {
      this.selectTempList = this.schemeTravPerson.fields[0].val || []
    }
  },
  watch: {
    selectPriceCalendarDate: {
      handler() {
        if (this.supportPriceCalendar) {
          const selectDay = dayjs(this.selectPriceCalendarDate)
          this.setStartTime(selectDay.format('YYYY-MM-DD'))
          const endTime = selectDay.add(1, 'month').add(-1, 'day')
          this.setEndTime(endTime.format('YYYY-MM-DD'))
        }
      },
      immediate: true
    },
    $route: {
      handler() {
        if (this.$route.query.viewName !== 'addUserForInsurance') {
          this.datePickerShow = false
          this.showEditPopup = false
          this.showSelectPopup = false
          Toast.clear()
        }
      }
    },
    //当数据源更新数据时 被选中的也需要更新
    travelPersonList() {
      this.selectTempList = this.selectTempList
        .filter(x => {
          const item = this.travelPersonList.find(b => b.tpid === x.tpid)
          return item
        })
        .map(d => {
          const item = this.travelPersonList.find(b => b.tpid === d.tpid)
          return item
        })
      if (this.guardianTemp && this.guardianTemp.tpid) {
        const item = this.travelPersonList.find(
          b => b.tpid === this.guardianTemp.tpid
        )
        if (item) {
          this.guardianTemp = {
            ...item
          }
        }
      }
    }
  },
  methods: {
    ...mapMutationNs([
      'setStartTime',
      'setEndTime',
      'setAdultPersonList',
      'setChildPersonList',
      'setGuardianInfo',
      'setTravelPersonList'
    ]),
    ...mapActions(['getTravelPersonList']),
    clickFold() {
      this.isFold = !this.isFold
    },
    add(isAddGuardian) {
      if (isAddGuardian) {
        this.isAddGuardian = isAddGuardian
      }
      this.isInitialized = true
      this.showSelectPopup = true
    },
    showEdit() {
      this.showEditPopup = true
      this.isEditInitialized = true
    },
    // select(item) {
    //   //单选情况
    //   if (this.travelPeronNum === 1) {
    //     if (
    //       this.selectTempList.length === 1 &&
    //       item.tpid === this.selectTempList[0].tpid
    //     ) {
    //       this.selectTempList = []
    //     } else {
    //       this.selectTempList = [item]
    //     }
    //     return
    //   }
    //   //多选情况
    //   const select = this.selectTempList.find(x => x.tpid === item.tpid)
    //   if (select) {
    //     this.selectTempList = this.selectTempList.filter(
    //       x => x.tpid !== item.tpid
    //     )
    //   } else {
    //     if (this.leftNum === 0) {
    //       this.$$toast(`只能选择${this.travelPeronNum}人`)
    //       return
    //     }
    //     this.selectTempList = this.selectTempList.concat(item)
    //   }
    // },
    datePickerConfirm(val) {
      this.datePickerShow = false
      const selectDay = dayjs(val)
      this.setStartTime(selectDay.format('YYYY-MM-DD'))
      const endTime = selectDay.add(1, 'month').add(-1, 'day')
      this.setEndTime(endTime.format('YYYY-MM-DD'))
    },
    selectDate() {
      if (!this.supportPriceCalendar) this.datePickerShow = true
    },
    hidePopup() {
      this.showSelectPopup = false
      this.isInitialized = false
      this.isAddGuardian = false
    },
    hideEditPopup() {
      this.showEditPopup = false
      this.isEditInitialized = false
    },
    unshiftPersonWithoutChecked() {
      this.editingPerson = { index: -1, isChecked: false }
      this.showEdit()
    },
    onEditBack() {
      this.hideEditPopup()
    },
    onEditSuccess(item) {
      // if (item.index === -1) {
      //   //新增
      //   this.setTravelPersonList([item, ...this.travelPersonList])
      // } else {
      //   //修改
      //   this.setTravelPersonList(
      //     this.travelPersonList.map(x => {
      //       if (x.tpid === item.tpid) {
      //         return item
      //       }
      //       return x
      //     })
      //   )
      // }
      //有改动重新请求吧
      this.getTravelPersonList({ vm: this, isCommit: true })
      this.hideEditPopup()
      //修改需要更新external外部出行人
      bus.onEditSuccess(item)
    },
    //点击确定选择回调
    usePersonList(_, listChecked) {
      if (this.isAddGuardian) {
        this.guardianTemp =
          (listChecked.length > 0 && { ...listChecked[0] }) || undefined
      } else {
        this.selectTempList = listChecked.map(x => {
          return {
            ...x
          }
        })
      }
      this.hidePopup()
    },
    onRemoved(tpid) {
      this.setTravelPersonList(
        this.travelPersonList.filter(x => x.tpid !== tpid)
      )
      //删除需要更新external外部出行人
      bus.onRemove(tpid)
    },
    onModify(item) {
      this.editingPerson = { ...item }
      this.showEdit()
    },
    deleteItem({ item, isGuardian }) {
      if (isGuardian) {
        this.guardianTemp = undefined
      } else {
        this.selectTempList = this.selectTempList.filter(
          x => x.tpid !== item.tpid
        )
      }
    },
    agree() {
      this.isAgree = !this.isAgree
    },
    confirm() {
      if (!this.isAgree) {
        this.$$toast('请先阅读《领取规则》《用户协议》')
        return
      }
      localStorage.setItem(AGREE_KEY, 1)
      if (!this.startTime || !this.endTime) {
        this.$$toast('请选择有效期')
        return
      }
      if (
        this.isChild &&
        !this.guardianTemp &&
        this.selectTempList.length > 0
      ) {
        this.$$toast('请选择监护人')
        return
      }
      const guardianCom = this.$refs.guardianRef
      if (guardianCom && guardianCom.errmsg) {
        this.$$toast(guardianCom.item.name + guardianCom.errmsg)
        return
      }
      const insuranceRef = this.$refs.insuranceRef
      console.log(insuranceRef)
      if (insuranceRef && insuranceRef.length > 0) {
        for (const insuranceCom of insuranceRef) {
          if (insuranceCom && insuranceCom.errmsg) {
            this.$$toast(insuranceCom.item.name + insuranceCom.errmsg)
            return
          }
        }
      }
      if (this.isChild) {
        this.setGuardianInfo(this.guardianTemp)
        this.setChildPersonList(this.selectTempList)
      } else {
        this.setAdultPersonList(this.selectTempList)
      }
      this.$router.go(-1)
    },
    goAgreement(type) {
      this.htmlContent =
        type === 1 ? this.insuranceInfo.rules : this.insuranceInfo.agreement
      this.htmlTitle = type === 1 ? '领取规则' : '用户协议'
      this.$router.push({
        query: {
          ...this.$route.query,
          viewName: 'agreementForInsurance',
          routerAction: ''
        }
      })
      this.$refs.mra.show()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.wrapper {
  min-height: 100vh;
  background: #f1f1f1
    url(https://hzwimspic-1251601690.image.myqcloud.com/072cc3dd-ce38-4fa9-9657-561884623672)
    no-repeat;
  background-size: 100% auto;
  padding: rem(24px) rem(24px) rem(400px);

  .product-info {
    background-color: white;
    border-radius: rem(16px);
    .header {
      width: 100%;
      height: rem(165px);
      padding-top: rem(39px);
      padding-left: rem(32px);
      background: url(https://hzwimspic-1251601690.image.myqcloud.com/353b8995-be63-44b3-ac06-503b98be90ef)
        no-repeat;
      background-size: cover;
      .detail {
        display: flex;
        align-items: center;
        .name {
          color: #000000;
          font-weight: 600;
          @include ellicpsis;
          line-height: rem(36px);
          max-width: rem(520px);
          font-size: rem(34px);
        }
        .tag {
          margin-left: rem(12px);
          display: flex;
          padding: 0 rem(10px);
          border-radius: rem(16px) rem(16px) rem(16px) 0;
          background: linear-gradient(270deg, #ff5900 0%, #ff2e2e 100%);
          span {
            color: #ffffff;
            font-size: rem(20px);
            transform: scale(0.9);
          }
        }
      }
      .true-name {
        color: #666666;
        margin-top: rem(8px);
        line-height: rem(36px);
        font-size: rem(24px);
      }
    }
    .company {
      margin: 0 0 0 rem(32px);
      display: flex;
      color: #666666;
      font-size: rem(28px);
      padding-top: rem(6px);
      padding-bottom: rem(28px);
      border-bottom: rem(1px) #eee solid;
      .title {
        width: rem(118px);
        display: flex;
        justify-content: space-between;
      }
      > span {
        margin-left: rem(12px);
      }
    }
    .date {
      height: rem(90px);
      margin: 0 rem(32px);
      display: flex;
      color: #666666;
      font-size: rem(28px);
      align-items: center;
      .title {
        width: rem(118px);
        display: flex;
        justify-content: space-between;
      }
      .date-wrapper {
        margin-left: rem(12px);
        display: flex;

        .start-time .end-time .zhi {
          color: #666666;
          font-size: rem(28px);
        }
        .select-start-time {
          color: #ccc;
          font-size: rem(28px);
        }
        .zhi {
          margin: 0 rem(8px);
        }
      }
    }
  }

  /deep/.van-cell {
    padding: rem(36px) rem(32px);
    background-color: transparent;
    .van-field__label {
      color: #666666;
      width: rem(152px);
      font-size: rem(28px);
    }
    .van-field__control {
      color: #121212;
      font-size: rem(28px);
    }
  }

  .guardian-wrapper {
    border-radius: rem(16px);
    background: #ffffff;
    margin-top: rem(20px);
    .header {
      height: rem(96px);
      color: #262626;
      padding: 0 rem(32px);
      border-bottom: rem(1px) #eee solid;
      font-weight: 600;
      display: flex;
      align-items: center;
      font-size: rem(30px);
      span {
        flex: 1;
        font-size: rem(24px);
        font-weight: normal;
        margin-left: rem(8px);
      }
    }
  }

  .receive-wrapper {
    border-radius: rem(16px);
    background: #ffffff;
    margin-top: rem(20px);

    .header {
      padding: rem(24px) rem(32px) 0;
      display: flex;
      align-items: baseline;
      .title {
        color: #262626;
        font-weight: 600;
        font-size: rem(30px);
        margin-right: rem(8px);
      }
      .num {
        font-weight: normal;
        flex: 1;
        font-size: rem(24px);
        span {
          color: #ff5900;
        }
      }
    }
    .trip {
      border-radius: rem(11px);
      background: #fff9e4;
      margin-left: rem(32px);
      margin-right: rem(32px);
      margin-top: rem(12px);
      padding: rem(16px) rem(24px);
      color: #de701d;
      font-size: rem(24px);
    }
  }

  .divider {
    margin-top: rem(24px);
    height: rem(1px);
    background: #eeeeee;
  }

  .person-wrapper {
    padding: rem(24px) 0;
    // margin-left: rem(32px);
    display: flex;
    border-bottom: rem(1px) #eee solid;
    align-items: center;
    &:last-child {
      border-width: 0;
    }
  }

  .add {
    color: #fd5e04;
    font-weight: 600;
    font-size: rem(26px);
    display: flex;
    align-items: center;
    &::before {
      content: '';
      display: inline-block;
      width: rem(24px);
      height: rem(24px);
      margin-right: rem(8px);
      background: url(https://hzwimspic-1251601690.image.myqcloud.com/3d72bbc9-74d8-4522-b9c4-72f65e1e8a49)
        no-repeat;
      background-size: contain;
    }
  }

  .add-big {
    height: rem(96px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fd5e04;
    font-weight: 600;
    font-size: rem(32px);
    &::before {
      content: '';
      display: inline-block;
      width: rem(30px);
      height: rem(30px);
      margin-right: rem(12px);
      background: url(https://hzwimspic-1251601690.image.myqcloud.com/3d72bbc9-74d8-4522-b9c4-72f65e1e8a49)
        no-repeat;
      background-size: contain;
    }
  }
  .explain {
    margin-top: rem(20px);
    text-align: center;
    color: #666666;
    font-size: rem(24px);
  }

  .bottom {
    position: fixed;
    bottom: 0;
    background-color: white;
    left: 0;
    right: 0;
    .agreement {
      overflow: hidden;
      color: #666666;
      display: flex;
      padding: rem(20px) rem(24px);
      font-size: rem(26px);
      img {
        width: rem(32px);
        height: rem(32px);
        margin-right: rem(12px);
      }
      span {
        color: #ff5900;
      }
    }
    .btn {
      height: rem(80px);
      margin: rem(20px) rem(24px);
      border-radius: rem(40px);
      background: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
      text-align: center;
      line-height: rem(80px);
      color: #ffffff;
      font-weight: 500;
      font-size: rem(32px);
    }
  }

  .popup {
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    .bd {
      position: relative;
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      overflow-scrolling: touch;
    }
  }

  .popup-title {
    margin: 0 rem(26px);
    height: rem(108px);
    @include ellicpsis;
    font-size: rem(32px);
    color: #121212;
    letter-spacing: 0;
    line-height: rem(108px);
    border-bottom: #ededed 1px solid;
  }

  .agreement {
    margin: rem(32px) rem(24px);
    font-size: rem(28px);
    text-align: justify;
  }
}

.btn-wrapper {
  height: rem(84px);

  p {
    margin-left: rem(32px);
    margin-right: rem(32px);
    margin-top: rem(12px);
    height: rem(60px);
    border-radius: 50px;
    justify-content: center;
    display: flex;
    align-items: center;
    background: #f5f5f5;
    color: #262626;
    font-size: rem(24px);
  }
  .icon {
    color: #262626;
    margin-left: rem(4px);
    font-size: rem(24px);
  }
}
</style>
